import '@/css/app.css'
import Alpine from 'alpinejs'
import Headroom from 'headroom.js'
import collapse from '@alpinejs/collapse'
import './cookie-consent-mode.js'
import './base/revealOnScroll.js'
import './base/parallax.js'
import './base/alignTo.js'
import './base/stickySections.js'
import './base/quote.js'
import './base/columns.js'
import './components/scrollProgress.js'
import './components/nav.js'
import './components/navDropdown.js'

import { gsap } from 'gsap'

import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

import Lenis from 'lenis'
const lenis = new Lenis({
    autoRaf: true,
    anchors: {
        offset: -150
    },
    prevent: (node) => {
        const classes = ['pm-wrapper']
        return classes.some((cls) => node.classList.contains(cls))
    },
    onComplete: () => {
        setTimeout(() => {
            ScrollTrigger.refresh()
        }, 200)
    }
})

lenis.on('scroll', () => {
    ScrollTrigger.update()
})

const headroom = () => {
    const logoBig = document.querySelector('.js-logo-big')
    const logoSmall = document.querySelector('.js-logo-small')
    const logoContainer = document.querySelector('.js-logo-container')
    const tl = gsap.timeline({
        scrollTrigger: {
            // markers: true,
            start: '+=80 top',
            toggleActions: 'play none play reverse'
        }
    })

    tl.to(logoBig, {
        yPercent: -100,
        duration: 0.3,
        ease: 'power3.inOut'
    })
        .to(logoSmall, {
            yPercent: -100,
            duration: 0.3,
            ease: 'power3.inOut'
        })

        .fromTo(
            logoContainer,
            {
                '--logo-multiplier': 68
            },
            {
                '--logo-multiplier': 15,
                duration: 0.3,
                ease: 'power3.inOut'
            },
            '<'
        )

    const headroom = new Headroom(document.querySelector('.header'), {
        offset: 100,
        onTop: function () {
            document.querySelector('body').classList.add('headroom--top')
            document.querySelector('body').classList.remove('headroom--not-top')
        },

        onNotTop: function () {
            document.querySelector('body').classList.remove('headroom--top')
            document.querySelector('body').classList.add('headroom--not-top')
        }
    }).init()

    const headroomMobile = new Headroom(
        document.querySelector('.header-mobile'),
        {
            offset: 100,
            onTop: function () {
                document.querySelector('body').classList.add('headroom--top')
                document
                    .querySelector('body')
                    .classList.remove('headroom--not-top')
            },

            onNotTop: function () {
                document.querySelector('body').classList.remove('headroom--top')
                document
                    .querySelector('body')
                    .classList.add('headroom--not-top')
            }
        }
    ).init()
}

// App main
const main = async () => {
    // De scan-layout heeft geen site-header: Headroom zou dan crashen en heel main() laten falen
    if (
        document.querySelector('.header') &&
        document.querySelector('.header-mobile')
    ) {
        headroom()
    }
    // Dit komt overeen met de twig var blockHandle
    // const blocks = []
    const components = [
        'fancybox',
        'swiper',
        'accordionComp',
        'langSwitcher',
        'googleMaps',
        'faq',
        'count',
        'plyr',
        'steps',
        'scan'
        // 'scrollProgress'
    ]

    const importPromises = []

    // for (const block of blocks) {
    //     const blockElements = document.querySelectorAll(`.${block}`)

    //     if (blockElements.length === 0) {
    //         continue
    //     }

    //     const importPromise = import(`./blocks/${block}.js`).then(
    //         ({ init }) => {
    //             blockElements.forEach((block) => {
    //                 importPromises.push(init(block))
    //             })
    //         }
    //     )

    //     importPromises.push(importPromise)
    // }

    for (const comp of components) {
        const compElements = document.querySelectorAll(`.${comp}`)
        if (compElements.length === 0) {
            continue
        }

        const importPromise = import(`./components/${comp}.js`).then(
            ({ init }) => {
                compElements.forEach((comp) => {
                    importPromises.push(init(comp, lenis))
                })
            }
        )

        importPromises.push(importPromise)
    }

    importPromises.push(
        import('./base/animations.js').then(({ initAnimations }) =>
            initAnimations()
        )
    )

    importPromises.push(
        import('./base/menu.js').then(({ initMenu }) => initMenu())
    )
    return await Promise.all(importPromises)
}

main().then(() => {
    console.log('Vite <3')
    window.Alpine = Alpine

    Alpine.plugin(collapse)
    Alpine.start()

    const anchor = getAnchor()
    if (anchor) {
        const anchorElement = document.querySelector(`#${anchor}`)
        if (anchorElement) {
            setTimeout(() => {
                lenis.scrollTo(anchorElement, {
                    offset: -150
                })
            }, 500)
        }
    }
})

const getAnchor = () => {
    var currentUrl = document.URL,
        urlParts = currentUrl.split('#')

    return urlParts.length > 1 ? urlParts[1] : null
}

if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log('HMR')
    })
}
